import { REDUX_ROUTING_PAGE_NAMESPACE } from "Common/routingUtils";
import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getIsExpanded } from "./redux/selectors";
import SettingsSidebarMenu from "./settingsSidebarMenu";
const mapStateToProps = (state) => ({
    routingPage: state[REDUX_ROUTING_PAGE_NAMESPACE].key,
    isExpanded: getIsExpanded(state)
});
const mapDispatchToProps = (dispatch) => ({
    onExpandedChanged: (isExpanded) => dispatch(actionCreators.setIsExpanded(isExpanded))
});
export default connect(mapStateToProps, mapDispatchToProps)(SettingsSidebarMenu);
